
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';
import { TypographySettings as TypographyType } from '@/utils/pdf-templates/types';

interface Props {
    typography: TypographyType;
    onChange: (val: TypographyType) => void;
}

export function TypographySettings({ typography, onChange }: Props) {
    const update = (key: keyof TypographyType, value: number) => {
        onChange({ ...typography, [key]: value });
    };

    return (
        <div className="space-y-5">
            <div>
                <div className="flex justify-between mb-2">
                    <Label>حجم العنوان</Label>
                    <span className="text-sm text-muted-foreground font-mono">{typography.titleSize}px</span>
                </div>
                <Slider min={14} max={28} step={1} value={[typography.titleSize]} onValueChange={([v]) => update('titleSize', v)} />
            </div>
            <div>
                <div className="flex justify-between mb-2">
                    <Label>حجم النص</Label>
                    <span className="text-sm text-muted-foreground font-mono">{typography.textSize}px</span>
                </div>
                <Slider min={10} max={18} step={1} value={[typography.textSize]} onValueChange={([v]) => update('textSize', v)} />
            </div>
            <div>
                <div className="flex justify-between mb-2">
                    <Label>وزن الخط</Label>
                    <span className="text-sm text-muted-foreground font-mono">{typography.fontWeight}</span>
                </div>
                <Slider min={400} max={900} step={100} value={[typography.fontWeight]} onValueChange={([v]) => update('fontWeight', v)} />
            </div>
            <div>
                <div className="flex justify-between mb-2">
                    <Label>تباعد الأسطر</Label>
                    <span className="text-sm text-muted-foreground font-mono">{typography.lineHeight}</span>
                </div>
                <Slider min={1.2} max={2.4} step={0.1} value={[typography.lineHeight]} onValueChange={([v]) => update('lineHeight', v)} />
            </div>
        </div>
    );
}
